// Stylesheets
// import './sass/style.scss';
// import $ from 'jquery';
//import jQuery from 'jquery';

//import 'bootstrap'; // This has now moved to the header and pulled in via CDN

//import './scripts/cookie';

import FastClick from 'fastclick';
FastClick.attach(document.body);


// console.log(slicknav);
// export for others scripts to use
// window["$"] = window.jQuery = $ = jQuery;
// if (!window.$) {
// 	window.$ = window.jQuery = require('jquery');
// }

//
// require("imports-loader?imports=slicknav/dist/jquery.slicknav.js");
require("imports-loader?imports=default|jquery|$!./js/custom/search.js");
// //import 'slicknav/dist/slicknav.css';

window.initMap = function() {
	console.log('initMap');
	var workshop = new google.maps.LatLng(mapdata.location.latitude,mapdata.location.longitude);
	var myOptions = {
		center: workshop,
		zoom: 15,
		mapTypeId: google.maps.MapTypeId.ROADMAP
	};
    var map = new google.maps.Map(document.getElementById("gmap"), myOptions);
	var marker = new google.maps.Marker({
		position: workshop,
		map: map,
		title:mapdata.title,
		animation: google.maps.Animation.DROP
	});
	var contentString = '<span id="span_map_bubble"><strong>'+mapdata.title+'</strong></span>';
	
	var infowindow = new google.maps.InfoWindow({
		content: contentString
	});
	google.maps.event.addListener(marker, 'click', function() {
		infowindow.open(map,marker);
	});
	// To add the marker to the map, call setMap();
	marker.setMap(map);
}
const $styleHeaderChange = $('.highlighter-box.ati2022 .media-body h5 > a, .highlighter-box.ati2024 .media-body h5 > a');
if( $styleHeaderChange.length){
	$styleHeaderChange.html(function(i, oldHtml) {
		var text = oldHtml.trim().split(" ");
		var last = text.pop();
		if(last === '#2022Index' || last === '2024') {
			return text.join(" ") + (text.length > 0 ? " <small class='lastWord'>" + last + "</small>" : last);
		}else{
			return oldHtml;
		}
	})
}